import * as angular from 'angular';
import {IController} from "angular";
import {FulfillmentStepModel} from "../../../fulfillment/models/fulfillment-step.model";
import {SplitService} from "../../../commons/services/split-service.service";

export class MultiAssignAgentDialogViewComponent implements IController {

  steps: FulfillmentStepModel[];
  serviceIds: string[];
  excludedStepIds: string[];
  selectedStepIds: string[];
  isAutoSelect: boolean;
  isIgnoreScore: boolean;
  isShowAllToggleVisible: boolean;
  onToggleAutoSelect: Function;
  onToggleIsIgnoreScore: Function;
  onSelectStep: Function;
  onAssign: Function;

  public selectedStepIdsMap: {};
  public excludedStepIdsMap: {};
  public fulfillmentStepItemSettings;


  constructor(private splitService: SplitService) {
  }

  $onInit() {
    this.fulfillmentStepItemSettings = this.splitService.getSiteFulfillmentStepItemSettings();

    this._initSelectStepIdsMap();
    this._initExcludedStepIdsMap();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.selectedStepIds && !changes.selectedStepIds.isFirstChange()) {
      this._initSelectStepIdsMap();

    }

    if (changes.excludedStepIds && !changes.excludedStepIds.isFirstChange()) {
      this._initExcludedStepIdsMap();
    }

  }

  onFulfillmentStepItemViewSettingsChange(settings) {
    this.fulfillmentStepItemSettings = angular.copy(settings);
    this.splitService.setSiteFulfillmentStepItemSettings(settings);
  }


  private _initSelectStepIdsMap() {
    this.selectedStepIdsMap = {}
    this.selectedStepIds.forEach((id: string) => {
      this.selectedStepIdsMap[id] = true;
    })
  }

  private _initExcludedStepIdsMap() {
    this.excludedStepIdsMap = {}
    this.excludedStepIds.forEach((id: string) => {
      this.excludedStepIdsMap[id] = true;
    })
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('multiAssignAgentDialogView', {
    bindings: {
      steps: '<',
      serviceIds: '<',
      excludedStepIds: '<',
      selectedStepIds: '<',
      isAutoSelect: '<',
      isIgnoreScore: '<',
      isShowAllToggleVisible: '<?',
      onToggleAutoSelect: '&',
      onSelectStep: '&',
      onAssign: '&',
      onToggleIsIgnoreScore: '&'
    },
    template: require('./multi-assign-agent-dialog-view.html').default,
    controller: MultiAssignAgentDialogViewComponent
  });
